import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// ANNUAL_PHYSICAL_UPDATE_ATTACHMENT

const mutation = gql`
  mutation annualPhysicalFormUpdateAttachment(
    $id: ID!
    $attachment: AnnualPhysicalFormUpdateAttachmentInput!
  ) {
    annualPhysicalFormUpdateAttachment(id: $id, attachment: $attachment) {
      id
      form_attachment {
        id
        title
        notes
      }
    }
  }
`
export default function useAnnualUpdateAttachment() {
  const { onMutate: onAnnualAttachmentUpdate, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'annualPhysicalFormUpdateAttachment',
    successMessage: 'Attachment updated'
  })

  return { onAnnualAttachmentUpdate, loading }
}
